import React from 'react';
import {connect} from "react-redux";
import Select from "react-select";
import * as utils from "../../../utils/underwriterRate";
import UnderwriterRateForm from "../UnderwriterRateForm";
import l10n from "../../../l10n/localization";
import {Button} from "react-materialize";
import * as underwriterRateActions from "../../../actions/underwriterRate";
import * as utilsCommon from "../../../utils/utils";
import * as creationActions from "../../../actions/creation";

class SelectUnderwriterRates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...props.formData};
    }

    componentDidMount() {
        utilsCommon.notNullNorUndefined(this.props.schema.fog.underwriter) &&
            this.props.dispatch(underwriterRateActions.fetchRates(this.props.schema.fog.underwriter.id, true));
    }

    onChange(value) {
        this.props.onChange(value);
    }

    render() {
        return (
            <div className="form-group field">
                <Button type="button" floating onClick={() => this.props.schema.openDrawer(UnderwriterRateForm, {item: null, fog: this.props.schema.fog}, creationActions.destroyingnewlyCreatedUnderwriterRate())} icon="add" className="add-button btn-md ml5"/>

                <label className="control-label" htmlFor="root_underwriterrate">
                    {l10n.cargo.underwriterRate}
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_underwriterrate"
                    value={this.props.formData}
                    options={utils.underwriterRatesToSelect(this.props.underwriterRates)}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children}
                                    <div className="pull-right mr25 input-button-wrapper">
                                        <i>
                                            <Button type="button" floating onClick={() => this.props.schema.openDrawer(UnderwriterRateForm, {item: props.value.item, fog: this.props.schema.fog}, creationActions.destroyingnewlyCreatedUnderwriterRate())} icon="edit" className="edit-button small"/>
                                        </i>
                                    </div>
                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        underwriterRates: state.underwriterRate.underwriterRates,
        loading: state.underwriterRate.loading
    });
})(SelectUnderwriterRates);


// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectUnderwriterRates.js